import {
  EmailReportCreateRequest,
  EmailReportInputs,
  EmailReportUpdateRequest,
} from '../../../types/app/emailReport.types';

export const convertDataFromInputToCreateRequest = (
  data: EmailReportInputs,
): EmailReportCreateRequest => ({
  name: data.name ? data.name : '',
  type: data.type ? data.type : '',
  emailSubject: data.emailSubject ? data.emailSubject : '',
  dateTimeFormat: data.dateTimeFormat ? data.dateTimeFormat : '',
  shiftId: data.shiftId ? data.shiftId : 0,
  timeZone: data.timeZone ? data.timeZone : '',
  intParam1: data.intParam1 ? data.intParam1 : 0,
  sendOnMonday: data.sendOnMonday ? data.sendOnMonday : false,
  sendOnTuesday: data.sendOnTuesday ? data.sendOnTuesday : false,
  sendOnWednesday: data.sendOnWednesday ? data.sendOnWednesday : false,
  sendOnThursday: data.sendOnThursday ? data.sendOnThursday : false,
  sendOnFriday: data.sendOnFriday ? data.sendOnFriday : false,
  sendOnSaturday: data.sendOnSaturday ? data.sendOnSaturday : false,
  sendOnSunday: data.sendOnSunday ? data.sendOnSunday : false,
  startOfWeek: data.startOfWeek ? data.startOfWeek : '',
});

export const convertDataFromInputToUpdateRequest = (
  data: EmailReportInputs,
): EmailReportUpdateRequest => ({
  id: data.id!,
  name: data.name ? data.name : '',
  type: data.type ? data.type : '',
  emailSubject: data.emailSubject ? data.emailSubject : '',
  dateTimeFormat: data.dateTimeFormat ? data.dateTimeFormat : '',
  shiftId: data.shiftId ? data.shiftId : 0,
  timeZone: data.timeZone ? data.timeZone : '',
  intParam1: data.intParam1 ? data.intParam1 : 0,
  sendOnMonday: data.sendOnMonday ? data.sendOnMonday : false,
  sendOnTuesday: data.sendOnTuesday ? data.sendOnTuesday : false,
  sendOnWednesday: data.sendOnWednesday ? data.sendOnWednesday : false,
  sendOnThursday: data.sendOnThursday ? data.sendOnThursday : false,
  sendOnFriday: data.sendOnFriday ? data.sendOnFriday : false,
  sendOnSaturday: data.sendOnSaturday ? data.sendOnSaturday : false,
  sendOnSunday: data.sendOnSunday ? data.sendOnSunday : false,
  startOfWeek: data.startOfWeek ? data.startOfWeek : '',
});
